/** D5 — the closed set of named RNG streams. Adding a roll to one leaves the rest untouched. */

export const RNG_STREAMS = [
  "battle.damage",
  "battle.morale",
  "battle.luck",
  "battle.ability",
  "battle.spell",
  // The open-field scatter (`battle/field.ts`). It is its own stream and not a
  // prefix of `battle.ability` because two consumers on one stream couple them:
  // a change to how many ability rolls a battle takes would silently reshuffle
  // every battlefield, and the correlation would be unattributable.
  "battle.field",
  "map.treasure",
  "map.encounter",
  "map.generation",
  "town.growth",
  "hero.levelup",
  "hero.offer",
  "ai.tiebreak",
] as const;

export type RngStream = (typeof RNG_STREAMS)[number];
